<template>
  <div class="home">
    <!-- <Topbar width="1180"></Topbar> -->

    <!-- <div class="navigation">
      <div class="navigation-logo" @click="returnBenBen"></div>
      <div class="navigation-right"></div>
    </div> -->
    <div class="nav-card">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        background-color="#FFFFFF"
        text-color="#333"
        active-text-color="#D20E0E"
      >
        <el-menu-item index="0">
          <router-link to="/">车架号查询</router-link>
        </el-menu-item>
        <el-menu-item index="1">
          <router-link :to="{ path: '/oeSearch' }">零件号查询</router-link>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="search flex-space-between">
      <div class="search-bar">
        <img src="../../assets/img/易查X-EPC.png" />
        <div class="search-bar-title">汽配精准查找，从这里开始</div>
        <div class="search-form" id="search-form">
          <div class="vinBrand-box">
            <div
              @click="chooseVinBrand(index)"
              :class="{
                'vinBrand-tag': true,
                active: index === activeTagIndex ? true : false
              }"
              v-for="(item, index) in shortVinBrandList"
              :key="item.brandCode"
            >
              {{ item.brandName }}
            </div>
          </div>
          <el-input
            :placeholder="vinTips"
            class="search-input"
            v-model="vin"
            maxlength="17"
            @keyup.enter.native="vinCodeSearch()"
            @focus="recordShow = true"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="vinCodeSearch()"
            ></el-button>
          </el-input>
          <div
            class="bdsug bdsugbg"
            id="bdsugbg"
            v-show="recordShow && recordList && recordList.length > 0"
          >
            <ul>
              <li
                v-for="(item, index) in recordList"
                :key="index"
                @click="clickRecord(item)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="search-bar-selection">
          <p v-show="prompt">
            <i class="el-icon-warning"></i>
            亲，您输入的VIN码，暂时不支持解析车型，
            <span @click="carTypeDialog">手动选车型</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 手动选车型 -->
    <ChooseCarType ref="chooseCarType" @confirm="jumpToCatalog"></ChooseCarType>

    <!-- vin码对应多个车型时，选择具体某一车型 -->
    <ChooseModel
      ref="chooseModel"
      :modelList="chooseModelList"
      @confirm="chooseModel"
    ></ChooseModel>

    <div class="support-brands"></div>
  </div>
</template>

<script>
import Topbar from "@/components/topbar/topbar.vue";
import ChooseCarType from "@/components/chooseCarType/chooseCarType.vue";
import ChooseModel from "@/components/chooseModel/chooseModel.vue";
import { getVtm, getAllShortVinBrand } from "@/api/service/catalog";
export default {
  components: {
    ChooseCarType,
    Topbar,
    ChooseModel
  },
  data() {
    return {
      activeIndex: "0",
      vin: "", // 输入的VIN码,测试：LBVHZ1105HMJ14266
      dialogTableVisible: false, //手动选车型弹窗的显示隐藏
      chooseModelList: [], //vin码对应多个车型列表
      recordShow: false, //搜索vin码记录历史显示状态
      prompt: false, //手动选车型提示的显示隐藏
      shortVinBrandList: [],
      activeTagIndex: 0,
      vinTips: "请输入17位VIN码"
    };
  },
  computed: {
    recordList() {
      let vinList = JSON.parse(localStorage.getItem("vinRecord"));
      return vinList;
    }
  },
  mounted() {
    window.addEventListener("click", this.handleKeyup);
    window.addEventListener("message", this.handleMessage);
    this.getAllShortVinBrand();
  },
  destroyed() {
    window.removeEventListener("click", this.handleKeyup);
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      const { platSign } = event.data;
      if (platSign) {
        sessionStorage.setItem("platSign", "platBB");
      }
    },
    /** 切换短vin码品牌 */
    chooseVinBrand(index) {
      this.activeTagIndex = index;
      this.vinTips =
        this.shortVinBrandList[index].brandCode === ""
          ? "请输入17位VIN码"
          : "请输入" +
            this.shortVinBrandList[index].brandName +
            "后" +
            this.shortVinBrandList[index].length +
            "位VIN码";
    },
    /** 获取支持短vin码查询的品牌 */
    getAllShortVinBrand() {
      /* this.axios
        .get("/getAllShortVinBrand", {
          token: sessionStorage.getItem("token")
        })
        .then(response => { */
      getAllShortVinBrand({
        token: sessionStorage.getItem("token")
      }).then(response => {
        let arr = [
          {
            brandName: "全部",
            brandCode: "",
            length: 17
          }
        ];
        if (response.data.status == 0) {
          arr = arr.concat(response.data.data);
        }
        this.shortVinBrandList = arr;
      });
    },
    /** 搜索vin码，获取车型信息 */
    vinCodeSearch() {
      if (!this.vin) {
        this.$message.warning("请输入 VIN 码！");
        this.prompt = true;
        return;
      }
      let vinLength = this.shortVinBrandList[this.activeTagIndex].length;
      if (this.vin.length !== vinLength) {
        this.$message.warning(this.vinTips);
        this.prompt = true;
        return;
      }
      /* this.axios
        .get("/vtm", {
          params: {
            vin: this.vin,
            brandCode: this.shortVinBrandList[this.activeTagIndex].brandCode
          }
        })
        .then(response => { */
      getVtm({
        vin: this.vin,
        brandCode: this.shortVinBrandList[this.activeTagIndex].brandCode
      }).then(response => {
        if (response.data.status == 0) {
          if (response.data.data.length == 0) {
            this.$message.error("无法根据VIN码查出配件信息");
            return;
          } else if (response.data.data.length == 1) {
            this.$router.push({
              path: "/catalog",
              query: {
                vin: this.vin,
                symbol: response.data.data[0].symbol,
                modelCname: response.data.data[0].element.modelCname,
                brandCode: this.shortVinBrandList[this.activeTagIndex].brandCode
              }
            });
          } else {
            this.$refs.chooseModel.dialogVisible = true;
            this.chooseModelList = response.data.data;
          }
          this.setLocalStorage(this.vin);
        } else {
          this.$message.error(response.data.message);
          this.prompt = true;
        }
      });
    },

    /** localStorage记录vin码历史搜索，最多记录6条 */
    setLocalStorage(vin) {
      if (localStorage.getItem("vinRecord")) {
        let vinList = JSON.parse(localStorage.getItem("vinRecord"));
        let item = vinList.find(list => {
          return list == vin;
        });
        if (!item) {
          if (vinList.length > 6) {
            vinList.pop();
          }
          vinList.push(vin);
          localStorage.setItem("vinRecord", JSON.stringify(vinList));
        }
      } else {
        let vinList = [];
        vinList.push(vin);
        localStorage.setItem("vinRecord", JSON.stringify(vinList));
      }
    },

    clickRecord(vin) {
      this.vin = vin;
      this.vinCodeSearch();
    },

    handleKeyup(event) {
      let e = event || window.event || arguments.callee.caller.arguments[0];
      let div = document.getElementById("search-form");

      let x = event.clientX;
      let y = event.clientY;
      let divx1 = div.offsetLeft;
      let divy1 = div.offsetTop;
      let divx2 = div.offsetLeft + div.offsetWidth;
      let divy2 = div.offsetTop + div.offsetHeight;

      if (x < divx1 || x > divx2 || y < divy1 || y > divy2) {
        //如果离开，则执行。。
        this.recordShow = false;
      }
    },

    /** 手动选择车型后跳转 */
    jumpToCatalog(val) {
      this.$router.push({
        path: "/catalog",
        query: {
          symbol: val[0],
          modelCname: val[1],
          brandCode: this.shortVinBrandList[this.activeTagIndex].brandCode
        }
      });
    },

    /** vin码对应多个车型，选择具体车型确定后跳转 */
    chooseModel(val) {
      this.$router.push({
        path: "/catalog",
        query: {
          symbol: val.symbol,
          modelCname: val.element.carBrandCname + val.diff,
          brandCode: this.shortVinBrandList[this.activeTagIndex].brandCode
        }
      });
    },

    // 返回犇犇
    returnBenBen() {
      window.open("https://www.apbenben.com", "_blank");
    },

    carTypeDialog() {
      this.$refs.chooseCarType.dialogVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/custom.scss";

.el-menu-demo {
  a {
    text-decoration: none;
    color: #333333;
    display: block;
  }
}
.is-active a {
  color: rgb(210, 14, 14);
}
.nav-card {
  padding: 0 20px;
  font-size: 15px;
  background: #fff;
  margin: 5px 0;
}

.navigation {
  width: 1180px;
  height: 100px;
  margin: 0 auto;
  background: $white-color;
  display: flex;
  justify-content: space-between;
  .navigation-logo {
    width: 210px;
    height: 100%;
    background: url(../../assets/img/benbenLogo.png) no-repeat;
    background-position: center center;
    cursor: pointer;
  }
  .navigation-right {
    width: 250px;
    height: 100%;
    background: url(../../assets/img/slogan.png) no-repeat;
    background-position: center center;
  }
}
.search {
  width: 100%;
  min-width: $min-width;
  height: 400px;
  background-image: url(../../assets/img/benbenBackground.png);
  background-position: center center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search-bar {
    width: $min-width;
    margin: 0 auto;
    .search-bar-title {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: $white-color;
      margin: 5px 0 20px 0;
    }
    .search-form {
      position: relative;
    }
    .search-input {
      width: 550px;
      ::v-deep .el-input__inner {
        border-top-left-radius: 0px;
      }
    }
    .bdsug {
      top: 64px;
      z-index: 100;
      width: 550px;
      height: auto;
    }
    .bdsugbg {
      position: absolute;
      width: 548px;
      background: #fff;
      border: 1px solid #ccc !important;
      ul li {
        padding: 2px 15px;
        color: #626675;
        line-height: 28px;
      }
      li {
        width: 519px;
        line-height: 25px;
        padding: 0 8px;
        &:hover {
          background-color: rgba(203, 46, 50, 0.1);
          color: $main-color;
          cursor: pointer;
        }
      }
    }
    .search-bar-selection {
      height: 40px;
      p {
        margin: 0;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: $white-color;
        line-height: 40px;
        span {
          font-weight: 800;
          text-decoration: underline;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.support-brands {
  width: 100%;
  height: 500px;
  min-width: $min-width;
  background: $white-color;
  background: url(../../assets/img/Bitmap.png) no-repeat;
  background-position: center 0;
}
</style>

<style scoped>
.search-input >>> .el-input__inner {
  border-right: 0;
}
.search-input >>> .el-input-group__append {
  background-color: #fff;
  font-size: 25px;
}
.vinBrand-box {
  width: 550px;
  height: auto;
}
.vinBrand-tag {
  width: auto;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  padding: 0 12px;
  cursor: pointer;
}
.vinBrand-tag.active {
  background: #fff;
  color: #ff0000;
}
</style>
